module.exports = __webpack_public_path__ + "img/baseball.f3abf71c.svg";